// extracted by mini-css-extract-plugin
module.exports = {"loadingDiv":"loadingcomponent-module--loadingDiv--2EO_v"};